module.exports = {
	VERSION: '0.0.1',
	VERSION_NUM: 1,
	ENV: 'production',
	//ENV: 'development',
	API_SERVER: 'https://sessack-api.okta.net',
	WEB_SERVER: 'https://sessack-api.okta.net',
	//API_SERVER: 'http://localhost:8080',
	// WEB_SERVER: 'http://localhost:8080',
	CMS_SERVER: 'https://www.okta.net/',
	EVENTS: {
		LOGIN_COMPLETE: 'LOGIN_COMPLETE',
		LOGOUT_COMPLETE: 'LOGOUT_COMPLETE',
		DATA_LOADING: 'DATA_LOADING',
		DATA_LOADED: 'DATA_LOADED',
		SET_HEADER_STATE: 'SET_HEADER_STATE',
		SET_HEADER_TITLE: 'SET_HEADER_TITLE',
		OPEN_SIDE_MENU: 'OPEN_SIDE_MENU',
		CLOSE_SIDE_MENU: 'CLOSE_SIDE_MENU',
		SET_SIDE_MENU: 'SET_SIDE_MENU',
		HIDE_FOOTER_MENU: 'HIDE_FOOTER_MENU',
		HAS_POPUP: 'HAS_POPUP',
		OPEN_MODAL: 'OPEN_MODAL',
		CLOSE_MODAL: 'CLOSE_MODAL',
		SAVE_MODAL: 'SAVE_MODAL',
		SAVE_REPORT: 'SAVE_REPORT',
		SAVE_REPORT_COMMENT: 'SAVE_REPORT_COMMENT',
		CONTRACT_UNACCEPT: 'CONTRACT_UNACCEPT',
		SAVE_MYPAGE: 'SAVE_MYPAGE',
		DATA_RETURN: 'DATA_RETURN',
	},
	HEADER_STATE: {
		MAIN: 'MAIN',
		NONE: 'NONE',
	},
	USER_TYPE: {
		TP: 'TP',
		COMPANY: 'COMPANY',
		OKTA: 'OKTA',
	},
	REPORT_TYPE: {
		PROGRAM: 'PROGRAM',
		MONTHLY: 'MONTHLY',
		FINAL: 'FINAL',
		MARKET_RESEARCH_REPORT: '타당성 및 시장조사',
		BUYER_MEETING_REPORT: '바이어 미팅',
		CERTIFICATION_REPORT: '해외인증',
		SAMPLE_REPORT: '샘플발송',
		TECHNIQUE_REPORT: '기술지원',
		STORE_AGENCY_REPORT: '유통채널 입점대행',
		EXHIBITION_REPORT: '전시회 대행',
		PROMOTION_REPORT: '홍보물 제작',
		TRANSLATION_REPORT: '통∙번역',
		ETC1_REPORT: '기타1',
		ETC2_REPORT: '기타2',
		ETC3_REPORT: '기타3',
		ETC4_REPORT: '기타4',
	},
};
